/* global axios */
import ApiClient from './ApiClient';

class N8nAPI extends ApiClient {
  constructor() {
    super('n8n', { accountScoped: true });
  }

  getSsoUrl(redirectTo = null) {
    const params = redirectTo ? { redirect_to: redirectTo } : {};
    return axios.get(`${this.url}/sso`, { params });
  }
}

export default new N8nAPI();
